import { PublicMarketingDetailPage } from "@/pages/public/marketing/marketing-detail";

export function TradeshowDetailPage() {
  return <PublicMarketingDetailPage categoryPath="tradeshows" />;
}

